<template>
  <div class="view-container">
    <BjDrawerForm
      ref="BjDrawerForm"
      :form="form"
      :rules="rules"
      label-width="120px"
      @handleConfirm="handleConfirm"
    >
      <BjDivider>{{ $t('screenWMS.lampConfig') }}</BjDivider>
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('screenWMS.basket')" prop="basketId">
            <BjInputNumber v-model="form.basketId" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('screenWMS.basket')" clearable/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('screenWMS.lamp')" prop="lampIndex">
            <BjInputNumber v-model="form.lampIndex" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('screenWMS.lamp')" clearable/>
          </el-form-item>
        </el-col>
      </el-row>
    </BjDrawerForm>
  </div>
</template>
<script>
import { waveApi } from '@/api';

const getDefaultForm = () => {
  return {
    basketId: null,
    lampIndex: null,
  };
};

export default {
  data() {
    return {
      // 表单参数
      isEdit: false,
      colSpan:24,
      form: getDefaultForm(),
    };
  },
  computed: {
    // 表单校验
    rules() {
      // const validate = (rule, value, callback) => {
      //   this.$nextTick(() => {
      //     if (!value) {
      //       callback(new Error(this.$t('inputText')));
      //     }
      //     if (this.form.basketNumberStart >= this.form.basketNumberEnd) {
      //       callback(new Error(this.$t('screenWMS.ps1')));
      //     }
      //     callback();
      //   });
      // };
      return {
        basketId: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        lampIndex: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      };
    },
  },
  methods: {
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(
        this.isEdit ? this.$t('editText') : this.$t('addText'),
      );
      this.form = Object.assign(getDefaultForm(), info || {});
    },
    handleConfirm() {
      const ADD_DATA = { 
        ...this.form,
        creationBy:this.$store.getters.userInfo.realName
      }
      const EDIT_DATA = { 
        ...this.form,
        lastUpdateBy:this.$store.getters.userInfo.realName
      }
      if (this.isEdit) {
        this.editApi(EDIT_DATA);
      }else{
        this.addApi(ADD_DATA);
      }
    },
    editApi(API_DATA) {
      waveApi.editLampPageList(API_DATA).then(res => {
        if (res.code == 200) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }else{
          this.$message.error(res.msg);
        }
      });
    },
    addApi(API_DATA) {
      waveApi.addLampPageList(API_DATA).then(res => {
        if (res.code == 200) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }else{
          this.$message.error(res.msg);
        }
      });
    },
    reFresh() {
      this.$emit('reFresh');
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
::v-deep .el-checkbox__label {
  width: 125px;
  height: 30px;
}
</style>
